import { Button, Flex, Text } from "@chakra-ui/react";
import { ClockCounterClockwise, Sparkle } from "@phosphor-icons/react";
import { RightSidebarHeader } from "components/Layout/RightSidebarWidget";
import DevOnly from "context/Auth/DevOnly";
import { useEffect, useState } from "react";
import { colors } from "theme/foundations/colors";
import AIChatHistoryPanel from "./AIChatHistoryPanel";
import AIChatWidget from "./AIChatWidget";
// import AITasksPanel from "./AITasksPanel";
/**
 * A chat panel that allows the user to chat with the AI assistant.
 * Figma: https://www.figma.com/design/uDql1qJTNBIvGnFDsOpWV4/ESG360-AIR?node-id=1329-36951&t=kiAkCqjBp03N59Wn-0
 */
const AIAssistPanel = () => {
  //   const [panel, setPanel] = useState("chat");
  const [threadId, setThreadId] = useState();
  const [panel, setPanel] = useState("chat");

  // Disable on report-writer. Do not remove this code without careful consideration.
  // Disabled because:
  // 1. AI Assist uses different data sources than the report writer! This is by design from the head of product.
  // -- This can then cause confusion as AI Assist can give different answers (and that has confused even the person who requested the setup).
  // Maybe rethink the design around data sources, but that's a bigger thing.
  // 2. AI Assist is not properly connected to the report writer for canvas edits, so it's not much use there.
  const isReportWriter = window.location.pathname.includes("/report-doc/editor");
  useEffect(() => {
    if (isReportWriter) {
      setPanel("disabled");
    }
  }, [isReportWriter]);
  // layout note: space-between to have header ... mesages+buttons+input
  return (
    <Flex id="aiAssistPanel" flexDirection="column" h="full" px={4}>
      <RightSidebarHeader Icon={Sparkle}>Ask AI</RightSidebarHeader>
      <Flex
        flexGrow={1}
        flexDirection="column"
        justifyContent="space-between"
        mb={4}
        bg={colors.sidebar_background}
        position="relative"
        maxH="85vh" /* manually tuned height to avoid scrollbar */
      >
        {panel === "chat" && <AIChatWidget threadId={threadId} setThreadId={setThreadId} />}
        {panel === "history" && <AIChatHistoryPanel setPanel={setPanel} setThreadId={setThreadId} />}
        {panel === "disabled" && <Text>This page has a dedicated AI Insights chat - please use that instead.</Text>}
        <DevOnly style={{ position: "absolute", bottom: 0, right: 0 }}>
          <Button onClick={(e) => setPanel(panel === "history" ? "chat" : "history")}>
            <ClockCounterClockwise size={24} />
          </Button>
        </DevOnly>
      </Flex>
    </Flex>
  );
};

export default AIAssistPanel;
